<template>
  <div class="credit">
    <div v-if="website">
      <a :href="website" target="_blank">{{ website }}</a>
    </div>
  </div>
</template>

<script>
import apiLookup from '@/api/lookup'

export default {
  name: 'Website',
  data() {
    return {
      name: '',
      website: ''
    }
  },
  mounted() {
    this.lookupInfo()
  },
  methods: {
    async lookupInfo() {
      const data = await apiLookup.lookupInfo()
      this.name = data.name
      this.website = data.website
    }
  }
}
</script>

<style lang="scss" scoped>
.credit {
  margin-bottom: 80px;
  text-align: center;
  color: $text-color;

  a {
    color: $text-color;
    text-decoration: underline;
    font-weight: 700;
  }
}
</style>
